import React from 'react';
import categoriesData from '../../data/categories.json';

export default function CategoryGrid() {
    const { categories } = categoriesData;

    return (
        <React.Fragment>
            <>
                <div className="container mx-auto px-4 py-8">
                    <div className="container mx-auto px-4 pt-8">
                        <h1 className="text-3xl md:text-4xl font-bold mb-2">All Categories</h1>
                        <p className="text-lg text-coolGray-600 mb-6">Select a category to view products.</p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                        {categories.map((category) => (
                            <a
                                href={`/categories/${category.id}`}
                                key={category.id}
                                className="block hover:no-underline"
                            >
                                <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow cursor-pointer">
                                    <div className="bg-gray-100 p-4">
                                        <img src={category.image} alt={category.name} className="w-full h-auto rounded-md" />
                                    </div>
                                    <div className="p-4">
                                        <h5 className="mb-2 text-base leading-tight text-darkCoolGray-900 font-bold tracking-tighter">{category.name}</h5>
                                        <p className="text-coolGray-500 mb-3">{category.productCount} Products</p>
<a
  href={`/categories/${category.id}`}
  className="mt-3 inline-block w-full py-2 px-4 bg-green-500 text-white text-center rounded-md font-medium hover:bg-green-600 transition"
>
  See All Products
</a>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </>
        </React.Fragment>
    );
}

